import CivilStatusCertificate from './civil-status-certificate';
import {
  CertificateRadio,
  CertificateType,
  CertificateValueBorn,
  CertificateValueCitizenship,
  CertificateValueCivilUnion,
  CertificateValueDeath,
  CertificateValueMarriage,
  CertificationFormVM,
} from 'front-office/view-models/document-birth-form';
import { memo } from 'react';
import { Grid, useEventCallback } from '@mui/material';
import { useFormikContext } from 'formik';
import SearchMessages, { MessageType } from 'shell/components/shared/search-messages';
import { noop } from 'shell/utils/noop';

const CertificationTypeComponent = (): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  const handleCertificateType = useEventCallback((item: CertificateRadio | null) => {
    let selectedCertificate = '';

    const isCopia =
      item?.value === CertificateValueBorn.copia ||
      item?.value === CertificateValueMarriage.copia ||
      item?.value === CertificateValueDeath.copia ||
      item?.value === CertificateValueCivilUnion.copia ||
      item?.value === CertificateValueCitizenship.copia;

    if (isCopia) {
      selectedCertificate = 'COPIACONFORME';
    }

    const isCertificato =
      item?.value === CertificateValueBorn.certificato ||
      item?.value === CertificateValueMarriage.certificato ||
      item?.value === CertificateValueDeath.certificato ||
      item?.value === CertificateValueCivilUnion.certificato ||
      item?.value === CertificateValueCitizenship.certificato;

    if (isCertificato) {
      selectedCertificate = 'CERTIFICATO';
    }

    const isEstratto =
      item?.value === CertificateValueBorn.estratto ||
      item?.value === CertificateValueMarriage.estratto ||
      item?.value === CertificateValueDeath.estratto ||
      item?.value === CertificateValueCivilUnion.estratto ||
      item?.value === CertificateValueCitizenship.estratto;

    if (isEstratto) {
      selectedCertificate = 'ESTRATTO';
    }
    formContext.setValues({ ...formContext.values, certificate: item, selectedCertificate });
  });

  return (
    <Grid container spacing={2}>
      {formContext.errors.certificate && formContext.touched.certificate ? (
        <Grid item xs={12} md={12}>
          <SearchMessages
            type={MessageType.Error}
            title={'E presente un errore di validazione'}
            messages={[{ id: 1, value: formContext.errors.certificate }]}
            visibility={!!formContext.errors.certificate}
            onChangeVisibility={noop}
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12} md={6}>
        <CivilStatusCertificate
          selectedValue={
            formContext.values.certificate?.type === CertificateType.nascita
              ? formContext.values.certificate?.value
              : undefined
          }
          id="birth"
          type={CertificateType.nascita}
          onChange={(value) => handleCertificateType(value)}
          label="Nascita"
          certificateValue={CertificateValueBorn}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CivilStatusCertificate
          selectedValue={
            formContext.values.certificate?.type === CertificateType.matrimonio
              ? formContext.values.certificate?.value
              : undefined
          }
          id="marriage"
          type={CertificateType.matrimonio}
          onChange={(value) => handleCertificateType(value)}
          label="Matrimonio"
          certificateValue={CertificateValueMarriage}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CivilStatusCertificate
          selectedValue={
            formContext.values.certificate?.type === CertificateType.morte
              ? formContext.values.certificate?.value
              : undefined
          }
          id="death"
          type={CertificateType.morte}
          onChange={(value) => handleCertificateType(value)}
          label="Morte"
          certificateValue={CertificateValueDeath}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CivilStatusCertificate
          selectedValue={
            formContext.values.certificate?.type === CertificateType.unioneCivile
              ? formContext.values.certificate?.value
              : undefined
          }
          id="civilUnion"
          type={CertificateType.unioneCivile}
          onChange={(value) => handleCertificateType(value)}
          label="Unione Civile"
          certificateValue={CertificateValueCivilUnion}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <CivilStatusCertificate
          selectedValue={
            formContext.values.certificate?.type === CertificateType.cittadinanza
              ? formContext.values.certificate?.value
              : undefined
          }
          id="citizenship"
          type={CertificateType.cittadinanza}
          onChange={(value) => handleCertificateType(value)}
          label="Cittadinanza"
          certificateValue={CertificateValueCitizenship}
        />
      </Grid>
    </Grid>
  );
};

CertificationTypeComponent.displayName = 'Form generality component';

const CertificationTypeForm = memo(CertificationTypeComponent);

export default CertificationTypeForm;
